(() => {
  if (customElements.get('akbar-size-chart')) return;
  customElements.define('akbar-size-chart', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.scope = this.closest('.product-info__block-list');
      if (!this.button || !this.scope) return;
      // Easify renders asynchronously and can replace its option heading.
      this.observer = new MutationObserver(() => this.position());
      this.observer.observe(this.scope, { childList: true, subtree: true });
      this.position();
    }

    position() {
      const option = [...this.scope.querySelectorAll('.easify-product-options input[type="radio"]')]
        .find(input => /(?:^|,)size$/i.test(input.name));
      const heading = option?.closest('.tpo_option-container')?.querySelector('.tpo_option-label-container');
      if (heading) {
        heading.classList.add('akbar-size-chart-heading');
        if (this.button.parentElement !== heading) heading.append(this.button);
        this.setAttribute('positioned', '');
      } else {
        if (this.button.parentElement !== this) this.prepend(this.button);
        this.removeAttribute('positioned');
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      // Return the owned link so theme-editor block replacement cannot orphan it.
      if (this.button && !this.contains(this.button)) this.prepend(this.button);
    }
  });
})();
